import SpamChartBar from '../components/SpamChartBar';
import { SpamDomainsColumns as columns } from '../columnsConfig';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import ApiLoadError from '@/components/errors/ApiLoadError';
import { useGetAnchorTextMutation } from '../api/backlinkAnchorText';
import { useRef } from 'react';
import {
  useGetSpamDomainsCountQuery,
  useGetSpamDomainsMutation
} from '../api/backlinkSpamDomains';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import { useGetMozSpamScoreQuery } from '../api/backlinkOverviewApi';
import { Col, Row } from 'react-bootstrap';
import MazScore from '../components/MazScore';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import SessionByBrowser from '../components/session-by-browser/SessionByBrowser';
import FiltersComponent from '@/app/common/components/filters/FiltersComponent';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useExportBacklinkTableMutation } from '../api/exportApi';
import useBacklinkQueryBody, {
  toOverviewQueryBody
} from '../hooks/useBacklinkQueryBody';

const SpamDomain = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [exportTable] = useExportBacklinkTableMutation();
  const body = useBacklinkQueryBody();
  const overviewBody = toOverviewQueryBody(body);
  const {
    data: mozSpamScoreRes,
    isFetching: mozSpamScoreLoading,
    isError: mozSpamScoreError,
    error: mozSpamScoreErrorDetails,
    refetch: refetchMozSpamScore
  } = useGetMozSpamScoreQuery(overviewBody);
  const {
    data: getSpamDomainsRes,
    isFetching: getSpamDomainsLoading,
    isError: getSpamDomainsError,
    error: getSpamDomainsErrorDetails,
    refetch: refetchSpamDomains
  } = useGetSpamDomainsCountQuery({
    ...overviewBody,
    page: 1,
    perPage: 50
  });
  const [
    getSpamDomainsFunc,
    {
      isError: isSpamDomainsMutationError,
      error: spamDomainsMutationError,
      isLoading: isSpamDomainsMutationLoading,
      reset: resetSpamDomainsMutation
    }
  ] = useGetSpamDomainsMutation();

  return (
    <div>
      <FiltersComponent
        preQueries={searchParams.toString()}
        columns={columns}
      />
      <Row className="g-3 mb-3">
        <Col md={6}>
          {!mozSpamScoreLoading ? (
            mozSpamScoreError ? (
              <ApiLoadError
                error={mozSpamScoreErrorDetails}
                isError={mozSpamScoreError}
                onRetry={() => refetchMozSpamScore?.()}
                isRetrying={mozSpamScoreLoading}
              />
            ) : (
              <SessionByBrowser noMore data={mozSpamScoreRes?.data} />
            )
          ) : (
            <TextLoading height={400} />
          )}
        </Col>
        <Col md={6}>
          {!mozSpamScoreLoading ? (
            mozSpamScoreError ? (
              <ApiLoadError
                error={mozSpamScoreErrorDetails}
                isError={mozSpamScoreError}
                onRetry={() => refetchMozSpamScore?.()}
                isRetrying={mozSpamScoreLoading}
              />
            ) : (
              <MazScore noMore data={mozSpamScoreRes?.data} />
            )
          ) : (
            <TextLoading height={400} />
          )}
        </Col>
      </Row>
      {/* <SpamChartBar /> */}
      {!getSpamDomainsLoading ? (
        getSpamDomainsError ? (
          <ApiLoadError
            error={getSpamDomainsErrorDetails}
            isError={getSpamDomainsError}
            onRetry={() => refetchSpamDomains?.()}
            isRetrying={getSpamDomainsLoading}
          />
        ) : isSpamDomainsMutationError ? (
          <ApiLoadError
            error={spamDomainsMutationError}
            isError={isSpamDomainsMutationError}
            onRetry={() => {
              resetSpamDomainsMutation?.();
              refetchSpamDomains?.();
            }}
            isRetrying={isSpamDomainsMutationLoading}
          />
        ) : (
          <AgGridWrapper
            table_name={pathname.split('/').slice(1, 3).join('/')}
            otherOptions={{
              rowHeight: 78,
              headerHeight: 52
            }}
            settings={{
              pagination: true,
              fullscreen: false,
              changeHeight: false,
              resetGrid: false,
              saveGrid: false,
              sideBar: false,
              export: {
                enabled: true,
                fetchFunction: exportTable,
                additionalData: overviewBody
              }
            }}
            stickyHorizontalScroll
            stickyHeader
            height="auto"
            fetchFunction={getSpamDomainsFunc}
            total={getSpamDomainsRes?.data?.total}
            data={getSpamDomainsRes?.data?.rows}
            columns={columns}
            additionalData={overviewBody}
          />
        )
      ) : (
        <AgGridSkeleton height="400px" />
      )}{' '}
    </div>
  );
};

export default SpamDomain;
